<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M17 8.99953C16.9673 4.58044 13.3429 1 8.90204 1C6.64898 1 4.59184 1.93543 3.12245 3.38696L1.65306 1.93543C1.42449 1.70964 1 1.87092 1 2.22573V6.29001C1 6.51581 1.16327 6.67709 1.39184 6.67709H5.57143C5.93061 6.67709 6.09388 6.25776 5.86531 6.03196L4.26531 4.48367C5.44082 3.29019 7.07347 2.5483 8.90204 2.5483C12.4939 2.5483 15.4327 5.45135 15.4327 8.99953C15.4327 12.58 12.4939 15.4508 8.90204 15.4508C7.20408 15.4508 5.70204 14.8379 4.52653 13.838C4.39592 13.7089 4.13469 13.7089 4.00408 13.838L3.44898 14.3863C3.28571 14.5476 3.28571 14.8056 3.44898 14.9669C4.88571 16.2249 6.81224 17.0313 8.90204 16.9991C13.3429 16.9991 17 13.4186 17 8.99953ZM11.5143 11.9026L12.0041 11.2897C12.102 11.0962 12.0694 10.8704 11.9061 10.7414L9.68571 9.12856V4.48367C9.68571 4.29013 9.4898 4.09659 9.29388 4.09659H8.5102C8.28163 4.09659 8.11837 4.29013 8.11837 4.48367V9.93496L10.9918 11.9994C11.1551 12.1284 11.4163 12.0961 11.5143 11.9026Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    name: 'HistoryIcon',
  };
</script>
